import { motion } from "framer-motion";
import { MapPin } from "@phosphor-icons/react";

const CONNECTIVITY = [
  { place: "Vaishnodevi Circle, SG Highway", time: "The address itself" },
  { place: "SP Ring Road Junction", time: "~5 min" },
  { place: "Koba Circle · Gandhinagar Corridor", time: "~10 min" },
  { place: "Sardar Vallabhbhai Patel Intl. Airport", time: "~25 min" },
  { place: "Ahmedabad CBD · Ashram Road", time: "~30 min" },
];

export default function LocationSection() {
  return (
    <section id="location" data-testid="location-section" className="grain bg-forest py-24 lg:py-32">
      <div className="relative z-10 mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 md:grid-cols-12 lg:gap-16 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="md:col-span-5"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Location</p>
          <h2 className="mt-4 font-serif text-2xl tracking-tight text-white sm:text-3xl lg:text-4xl">
            SG Highway's most connected address
          </h2>
          <p className="mt-6 text-base leading-relaxed text-white/70">
            Positioned between Ahmedabad and Gandhinagar, Shantigram puts both cities — and the airport — within an
            easy drive.
          </p>
          <ul className="mt-10 space-y-5">
            {CONNECTIVITY.map((c) => (
              <li key={c.place} className="flex items-center justify-between border-b border-white/10 pb-4">
                <span className="flex items-center gap-3 text-sm text-white/90">
                  <MapPin size={18} weight="fill" className="shrink-0 text-gold" />
                  {c.place}
                </span>
                <span className="text-sm font-semibold text-gold">{c.time}</span>
              </li>
            ))}
          </ul>
          <p data-testid="nearby-areas" className="mt-10 text-xs leading-relaxed text-white/50">
            Also serving buyers and tenants across Vaishnodevi, Gota, Chandkheda, Motera, Science City, Zundal, GIFT
            City and the wider Ahmedabad–Gandhinagar corridor.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="overflow-hidden rounded-lg md:col-span-7"
        >
          <iframe
            data-testid="location-map"
            title="Adani Shantigram location map"
            src="https://www.google.com/maps?q=Adani+Shantigram,+SG+Highway,+Ahmedabad&output=embed"
            className="h-[420px] w-full border-0 md:h-full md:min-h-[520px]"
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  );
}
